export default __webpack_public_path__ + "beta-maps-examples-user-location-view-thumbnail-960-4125d55896a94765054f5a729d35ae15.png";